export default __webpack_public_path__ + "static/2-mobile-df6ba8f0ab5cb6bca24c7b54c9def0fe.svg";